module.exports = __webpack_public_path__ + "img/thumb-l-appeau-qui-desire.48709972.jpg";